<template>
  <v-container>
    <v-layout
      wrap
      justify-center
      align-center
      style="height:70vh"
    >
      <v-flex
        xs12
        md5
      >
        <div class="thank-you-wrapper">
          <div
            class="payment-step-5"
          >
            <LottieWeb
              class="animated-icon"
              :animation-data="CardDoneJSON"
              :auto-play="true"
              :loop="false"
              :speed="0.5"
            />
            <div class="d-flex flex-column align-center">
              <div class="header mb-1">
                {{ $t('paymentProcess.step5.title') }}
              </div>
              <div class="description">
                {{ $t('paymentProcess.step5.description') }}
              </div>
            </div>
            <!--          <div-->
            <!--            class="amount"-->
            <!--            v-html="amount"-->
            <!--           />-->
            <v-btn
              class="back-button"
              color="light"
              block
              large
              @click="$router.push('/dashboard')"
            >
              {{ $t('paymentProcess.step4.backButton') }}
            </v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LottieWeb from "lottie-web-vue";
import CardDoneJSON from "@/images/lottie/card_done.json"

export default {
  name: "ThankYou",
  components: {LottieWeb},
  data() {
    return {
      CardDoneJSON,
    }
  },
}
</script>

<style lang="scss" scoped>
.thank-you-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;

}

.payment-step-5 {
  padding: 40px;
  border-radius: 30px;
  background: var(--light-theme-surface-background, #FFF);
  /* shadow-40 */
  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.07);
  max-width: 480px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  @media (max-width: 599px) {
    gap: 24px;
  }

  .animated-icon {
    width: 64px;
  }

  .header {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
    @media (max-width: 599px) {
      font-size: 17px;
    }
  }

  .description {
    color: var(--light-theme-surface-color-70, rgba(49, 57, 44, 0.70));
    text-align: center;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.5;
  }

  .amount {
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    line-height: 150%;
    @media (max-width: 599px) {
      font-size: 24px;
    }
  }

  .back-button {
    text-transform: unset !important;
  }
}
</style>